import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2 } from 'angulartics2';
import { NGXLogger } from 'ngx-logger';
import { ErrorModalComponent, IErrorModalParameters } from './error-modal/error-modal.component';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  // Error handling is important and needs to be loaded first.
  // Because of this we should manually inject the services with Injector.
  constructor(private _injector: Injector) {}

  // ErrorHandler interface declares error parameter as type any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: HttpErrorResponse | Error | any): void {
    const logger = this._injector.get<NGXLogger>(NGXLogger);
    const ngbModal = this._injector.get<NgbModal>(NgbModal);
    const angulartics = this._injector.get<Angulartics2>(Angulartics2);

    // See Angular issue https://github.com/angular/angular/issues/27840 for why the second test is needed now.
    if (error instanceof HttpErrorResponse || (error.rejection && error.rejection instanceof HttpErrorResponse)) {
      return;
    }
    const modalInstance = ngbModal.open(ErrorModalComponent);
    const instance = modalInstance.componentInstance;
    instance.parameters = { error } as IErrorModalParameters;

    // The error object cannot be serialized by JSON.stringify, so we must manually construct the log object.
    logger.error('globalError', {
      error: {
        name: error.name,
        message: error.message,
        stack: error.stack,
      },
    });
    // Google only takes a description.
    // See https://github.com/angulartics/angulartics2/blob/master/src/lib/providers/ga/ga.ts
    angulartics.exceptionTrack.next({ description: error.name + '-' + error.message });
  }
}
